export const ACTION_LABELS: Record<string, string> = {
  // Companies
  'company.create': 'Empresa Criada',
  'company.update': 'Empresa Atualizada',
  'company.delete': 'Empresa Excluída',
  'company.status_change': 'Status da Empresa Alterado',
  'company.settings_update': 'Configurações da Empresa Atualizadas',
  
  // Users
  'user.create': 'Usuário Criado',
  'user.update': 'Usuário Atualizado',
  'user.delete': 'Usuário Excluído',
  'user.invite': 'Convite Enviado',
  'user.role_change': 'Permissão Alterada',
  'user.password_reset': 'Senha Redefinida',
  'user.status_change': 'Status do Usuário Alterado',
  
  // Plans & Systems
  'plan.create': 'Plano Criado',
  'plan.update': 'Plano Atualizado',
  'plan.delete': 'Plano Excluído',
  'plan.activate': 'Plano Ativado',
  'plan.deactivate': 'Plano Desativado',
  'system.create': 'Sistema Criado',
  'system.update': 'Sistema Atualizado',
  'system.delete': 'Sistema Excluído',
  
  // Company Plans
  'company_plan.assign': 'Plano Atribuído',
  'company_plan.remove': 'Plano Removido',
  'company_plan.upgrade': 'Plano Atualizado (Upgrade)',
  'company_plan.downgrade': 'Plano Atualizado (Downgrade)',
  'company_plan.trial_start': 'Trial Iniciado',
  'company_plan.trial_expire': 'Trial Expirado',
  
  // Modules
  'module.assign': 'Módulo Atribuído',
  'module.remove': 'Módulo Removido',
  'module.seats_change': 'Assentos do Módulo Alterados',
  
  // Billing
  'billing.invoice_create': 'Fatura Criada',
  'billing.invoice_cancel': 'Fatura Cancelada',
  'billing.invoice_delete': 'Fatura Excluída',
  'billing.payment_process': 'Pagamento Processado',
  'billing.manual_payment': 'Pagamento Manual Registrado',
  'billing.settings_update': 'Configurações de Faturamento Atualizadas',
  'billing.automation.execute': 'Automação de Faturamento Executada',
  'billing.automation.success': 'Automação Concluída com Sucesso',
  'billing.automation.error': 'Erro na Automação de Faturamento',
  'billing.email_sent': 'Email de Fatura Enviado',
  'billing.email_failed': 'Falha no Envio de Email',
  
  // Mercado Pago
  'mp.sync.execute': 'Sincronização MP Executada',
  'mp.sync.success': 'Sincronização MP Concluída',
  'mp.sync.error': 'Erro na Sincronização MP',
  'mp.payment.processed': 'Pagamento MP Processado',
  'mp.payment.updated': 'Pagamento MP Atualizado',
  'mp.payment.activated': 'Pagamento MP Ativado',
  
  // Permissions
  'permission.grant': 'Permissão Concedida',
  'permission.revoke': 'Permissão Revogada',
  'role.create': 'Função Criada',
  'role.delete': 'Função Excluída',
};

export const ENTITY_TYPE_LABELS: Record<string, string> = {
  'company': 'Empresa',
  'user': 'Usuário',
  'plan': 'Plano',
  'system': 'Sistema',
  'module': 'Módulo',
  'invoice': 'Fatura',
  'payment': 'Pagamento',
  'settings': 'Configurações',
  'role': 'Função',
  'permission': 'Permissão',
};

export function getActionLabel(action: string): string {
  return ACTION_LABELS[action] || action;
}

export function getEntityTypeLabel(entityType: string): string {
  return ENTITY_TYPE_LABELS[entityType] || entityType;
}
